import React, { useState, useEffect, use } from "react";
//MUI
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Collapse } from "@mui/material";
//translation
import useTranslation from "../hooks/useTranslation";
//graphQL
import { getAllServices } from "../graphql/services";
import { Margin } from "@mui/icons-material";

const HelpLayout = () => {
  const [services,setServices] = useState(null)
  const {t} = useTranslation();
const ftechAllServices = async () => {
  const {data} = await getAllServices()
  setServices(data?.services);
}
useEffect(()=> {
  ftechAllServices()
},[])

  return (
    <div className="h-full pt-[76px] lg:pt-[109px] ">
      <div className="relative">
        <img
          src="/images/help_bg.jpg"
          className="w-full h-[200px] lg:h-[400px] "
        />
        <div className="absolute bg-[#000000] bg-opacity-40 top-0  h-[200px]   lg:h-[400px] w-full flex flex-col justify-center gap-6 md:gap-10 items-center py-6 lg:py-10">
          <p className="text-white text-2xl md:text-4xl lg:text-6xl font-MyriadPro font-semibold ">
            {t("Centre d’aide")} FiDarri
          </p>
          <p className="text-white text-base lg:text-xl ">
            {t("Comment pouvons-nous vous aider ?")}
          </p>
          {/* <p className="text-white text-lg underline cursor-pointer">
            contact us{" "}
          </p> */}
          {/* <div className="w-3/4 lg:w-1/3 mx-auto bg-white rounded-[5px] overflow-hidden relative flex items-center">
            <div className="px-[10px] flex items-center justify-center">
              <img src="/svg/search.svg" alt="search icon" />
            </div>
            <input
              type="text"
              placeholder={t("Chercher une information")}
              className="outline-0 border-0 pr-[20px] py-[10px] grow"
            />
          </div> */}
        </div>
      </div>
      <div className="relative max-w-[1366px] w-full h-full mx-auto py-[100px]  flex flex-col gap-4 md:gap-8 lg:gap-12 items-center">
        <img
          className="absolute top-10 block mx-auto "
          src="/svg/logo_watermark.svg"
        />

        <p className="text-[#544B4B] text-xl md:text-3xl lg:text-5xl font-MyriadPro font-semibold ">
          {t("Bienvenue à")} FiDarri
        </p>

        <p className="text-[#707070] text-md lg:text-xl lg:text-3xl w-3/4  lg:w-1/2 text-center ">
        {t("Toutes les informations dont vous avez besoin pour naviguer sur notre site Web et profiter au maximum de nos services.")}
        </p>
        <div className="w-4/5 md:w-2/3 flex flex-col items-center gap-2 my-4">
          <Question
            question={t("Comment fonctionne la platform Fiddari  ?")}
            answer={t("La plateforme FIDDARI met simplement à disposition des freelancer qualifiés dans leurs domaines pour fournir les services demandés par les abonnés de la plateforme en tant que clients")}
          />
          <Question
            question={t("Quels types de services qui sont proposés sur Fiddari actuellement ?")}
            answer={
              services && services.map((service, index) => (
                <ul key={index}>
                  <li className={`list-disc px-3 text-[bg-primary] ${index !== services.length - 1 ? 'mb-4' : ''}`}>
                    {service.service === 'MAID'
                      ? t("Femme de ménage")
                      : service.service === 'ELDERLY_SITTER'
                      ? t('Garde malade')
                      : ''
                    }
                  </li>
                </ul>
              ))
            }
          />
          <Question
            question={t("Comment puis-je réserver un freelancer sur Fiddari ?")}
            answer={
              <ul className="list-decimal p-3">
                <li>{t("S’identifier avec un compte client ou créer un nouveau sur portail client  si vous avez pas.")}</li>
                <li>{t("Aller au portail main d’oeuvre et sélectionne le freelancer selon les besoins du filtre")}</li>
                <li>{t("Cliquez sur le boutton Embocher")}</li>
                <li>{t("Choisis une maison une date et service correspondant")}</li>
                <li>{t("Cliquez sur aller à l’étape suivante")}</li>
                <li>{t("Appliquez le code coupon pour benificier une réduction sur le prix si c’est disponible")}</li>
                <li>{t("En fin tu peut réserver le freelancer en cliquant sur confirmer et envoyer")}</li>
                <li>{t("Suiver votre demande avec votre freelancer et felicitation !.")}</li>
              </ul>
            }
          />
          <Question
            question={t("Comment payer ?")}
            answer={
              <>
                <p className="pb-3">
                  {t("Le payment se faite deux fois ; enter le client et le freelancer ,et entre le freelancer et l'administration Fiddari.")}
                </p>
                <h1 className="text-primary text-xl
                font-bold">
                  {t("Entre client et freelancer")}
                </h1>
                <ul className="list-disc p-3">
                  <li>
                  {t("On note que le payment ce faite en cash entre le client el leur freelancer appropriée après que la mission terminé")}</li>
                </ul>
                <h1 className="text-primary text-xl
                font-bold">
                  {t("Entre le freelancer et l'administration FIDDARI")}
                </h1>
                <ul className="list-decimal p-3">
                  <li>{t("Le payment est visionné en bref dans le module DÉPENSES après la connexion en tant que freelancer")} </li>
                  <li>{t("Dans la section ‘Factures hebdomadaire'les factures généré automatiquement par la platforme chaque semaine")}</li>
                  <li>{t("Le freelancer doit payer à l’administration FIDDARI 20% du totale généré pour chaque facture")} </li>
                  <li>{t("Si le totale à payer généré ne dépasse pas 500da ,la facture accumulé jusqu’à atteindre cette dernier seuil.")}</li>
                  <li>{t("Si le totale à payer  généré dépasse 500da , le freelancer soumettre la facture pour payer par CCP ou par compte bancaire en envoi un reçu du transaction à l’administration FIDDARI.")}</li>
                  <li>{t("Le freelancer ne doit pas dépasse un délai de 7 jours pour payer, sinon l’administration peut bloque le compte du concerné jusqu’il payer.")}</li>
                  <li>{t("après que le freelancer paye avec succès il attend la validation par l’administration")}</li>
                  <li>{t("l’administration vérifie le reçu ccp/bancaire pour valider le payement.")}</li>
                </ul>
              </>
            }
          />
          <Question
            question={
              t("Que se passe-t-il si je dois modifier mes information?")
            }
            answer={t("tu peut consulter et modifier votre infomation dans le module paramettre dans votre propre compte")}
          />
        </div>

        <div className="w-full flex justify-center">
          <img
            src="/svg/message_illustration.svg"
            className="w-[150px] lg:w-auto"
          />
        </div>
        <div className="w-3/4 md:w-1/3 flex justify-center text-center">
          <p className="text-base md:text-lg text-[#544B4B] ">
            {t("Vous ne trouvez pas la réponse que vous cherchez ?")}
            <span className="text-primary underline cursor-pointer">
              {t("Veuillez contacter notre equipe")}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default HelpLayout;

const Question = ({ question, answer }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className="bg-[#F5F5F5]  rounded py-4 lg:py-6 px-3 lg:px-6 text-[#33363F] w-full">
        <div className="flex justify-between items-center  md:space-x-5 lg:space-x-10 ">
          <p className="text-md md:text-xl lg:text-2xl">{question}</p>

          <div className="text-dark_gray">
            {open === true && (
              <KeyboardArrowUpIcon
                onClick={() => {
                  setOpen(!open);
                }}
                fontSize="large"
                className="cursor-pointer"
              />
            )}
            {open === false && (
              <KeyboardArrowDownIcon
                onClick={() => {
                  setOpen(!open);
                }}
                fontSize="large"
                className="cursor-pointer"
              />
            )}
          </div>
        </div>
        <Collapse in={open}>
          <div
            id="response"
            // className={` ${open === true ? "block  " : "hidden"}`}
          >
            <div className={`text-sm md:text-lg text-[#544B4B]  mt-6 `}>
              {answer}
            </div>
          </div>
        </Collapse>
      </div>
    </>
  );
};
